export const personaTTS = {
	'소방관 리쿠': '저는 불이 나면 제일 먼저 달려가는 용감한 소방관입니다.',
	'환경지킴이 리쿠': '저는 지구를 지키는 환경 지킴이입니다~',
	'선생님 리쿠': '저는 아이들의 궁금증을 모두 해결해 주는 똑똑! 선생님이에요!',
	'경찰관 리쿠': '저는 언제나 모두를 지켜주는 든든한 경찰관입니다.',
	'의사 리쿠': '저는 딱 보면 척! 아픈 곳을 고쳐주는 멋진 의사입니다!',
	'간호사 리쿠': '저는 다정하게 보살펴주는 친절한 간호사예요~',
	'천문학자 리쿠': '저는 밤 하늘을 보며 별을 연구하는 똑똑한 천문학자입니다!',
	'요리사 리쿠': '저는 뚝딱뚝딱! 맛있고, 건강함을 만드는 행복 요리사입니다!',
	default: '안녕하세요! 저는 리쿠입니다. 무엇을 도와드릴까요?',
};

export const personaMotion = {
	'소방관 리쿠': 'greet_arm',
	'환경지킴이 리쿠': 'greet_arm',
	'선생님 리쿠': 'greet_arm',
	default: 'greet_arm',
};
